module.exports = __webpack_public_path__ + "img/analytics.80bf7a3a.svg";